import { ConfigSetting } from '@src/shared/models';

export const convertStringToNumberArray = (value: string): number[] => {
  return value
    .split(',')
    .map((str) => str.trim())
    .map(Number)
    .filter((num) => !isNaN(num));
};

export const convertSettingsResponse = (settings: ConfigSetting[]) => {
  const result = {
    paymentPoolingIntervals: null as number[] | null,
    emailValidationInterval: null as number | null,
    idwallPoolingIntervals: null as number[] | null,
  };

  const settingsMap = new Map(
    settings.map((setting) => [setting.key, setting.value])
  );

  try {
    const intervalsValue = settingsMap.get(
      'ENV_CCB_PAYMENT_INFORMATION_WAIT_TIME_IN_SECONDS'
    );

    if (intervalsValue) {
      const intervals = convertStringToNumberArray(intervalsValue);

      if (intervals.length > 0) {
        result.paymentPoolingIntervals = intervals;
      }
    }

    const idwallIntervalsValue = settingsMap.get(
      'PROPOSAL_RETRY_PULLING_INTERVAL'
    );

    if (idwallIntervalsValue) {
      const idwallIntervals = convertStringToNumberArray(idwallIntervalsValue);

      if (idwallIntervals.length > 0) {
        result.idwallPoolingIntervals = idwallIntervals;
      }
    }

    const emailIntervalValue =
      settingsMap.get('EMAIL_VALIDATION_CODE_RESEND_WAIT_SECONDS') ?? '60';

    if (emailIntervalValue) {
      const emailInterval = parseInt(emailIntervalValue, 10);
      if (!isNaN(emailInterval)) {
        result.emailValidationInterval = emailInterval;
      }
    }
  } catch (error) {
    throw new Error(
      `Falha ao processar configurações: ${error instanceof Error ? error.message : 'Erro desconhecido'}`
    );
  }

  return result;
};
